import React from "react";
import { EmployementEquity1MultiLevelChart } from "../../Component/Common/Components/Charts/EmploymentEquity/EmployementEquity1MultiLevelChart";
import { EmployementEquity1PieChart } from "../../Component/Common/Components/Charts/EmploymentEquity/EmployementEquity1PieChart";
import { EmploymentEquity1BlockChart } from "../../Component/Common/Components/Charts/EmploymentEquity/EmploymentEquity1BlockChart";
import { EmployementEquityIncomeDifferentialsChart } from "../../Component/Common/Components/Charts/EmploymentEquity/EmploymentEquityIncomeDifferentialsGraphChart";
import { MovementHeadcountChart } from "../../Component/Common/Components/Charts/EmploymentEquity/MovementHeadcountChart";
import { MovementTypes } from "../../Component/Model/Enum/BEE123Enums";
import { ChartType } from "../../Component/Model/Enum/ChartType";
import { IChartFactoryProps } from "./ChartFactory";
import { EmployementEquityPlanTrackingComboChart } from "../../Component/Common/Components/Charts/EmploymentEquity/EmployementEquityPlanTrackingComboChart";
import { raceGenderConfigs } from "../../Component/Common/Constants/EEPlanRaceGenderPairsGraphHeadings";

export const ChartFactoryEmployeeEquity: React.FC<IChartFactoryProps> = (
  props: IChartFactoryProps
) => {

  if (props.chartType === ChartType.EmployeeHeadCountChart1DoubleColumnChart)
    return <EmployementEquity1MultiLevelChart {...props} />;

  if (props.chartType === ChartType.IncomeDifferentialGraph)
    return <EmployementEquityIncomeDifferentialsChart {...props} />;

  if (props.chartType === ChartType.IncomeDifferential1Analysis)
    return <EmploymentEquity1BlockChart {...props} />;

  if (props.chartType === ChartType.IncomeDifferential2Analysis)
    return <EmploymentEquity1BlockChart {...props} />;

  if (props.chartType === ChartType.EmployeeHeadCount1PieChart)
    return <EmployementEquity1PieChart {...props} />;

  if (props.chartType === ChartType.RecruitmentHeadcountChart)
    return <MovementHeadcountChart {...props} movementType={MovementTypes.Recruitment} />;

  if (props.chartType === ChartType.PromotionHeadcountChart)
    return <MovementHeadcountChart {...props} movementType={MovementTypes.Promotion} />;

  if (props.chartType === ChartType.TerminationHeadcountChart)
    return <MovementHeadcountChart {...props} movementType={MovementTypes.Termination} />;

  if (props.chartType === ChartType.EEPlanTrackingChartAfricanMale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[0]} />;

  if (props.chartType === ChartType.EEPlanTrackingChartAricanFemale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[1]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartColouredMale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[2]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartColouredFemale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[3]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartIndianMale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[4]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartIndianFemale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[5]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartWhiteMale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[6]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartWhiteFemale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[7]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartNonRSAMale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[8]}/>;

  if (props.chartType === ChartType.EEPlanTrackingChartNonRSAFemale)
    return <EmployementEquityPlanTrackingComboChart {...props} raceGenderPair={raceGenderConfigs[9]}/>;

  return null;
};
